<style scoped>
  .agreement-title {
    margin-bottom: 20px;
      padding: 0px 25px;
  }
  .agreement-content {
      box-sizing: border-box;
    height: calc(100% - 170px);
    background-color: #f9fcff;
    /*padding: 44px;*/
      margin-left: 25px;
      margin-right: 25px;
    margin-bottom: 20px;
      /*overflow-y: auto;*/
  }
  .agreement-action{
      padding: 0 25px;
  }
  .agreement-action p {
    padding-left: 24px;
  }
  .agreement-btn {
    cursor: pointer;
    border-radius: 20px;
    color: #fff;
    text-align: center;
    width: 104px;
    height: 32px;
    flex-grow: 0;
    margin: 20px auto 0;
    padding: 7px 16px 9px;
    background-image: linear-gradient(to bottom, rgba(90, 156, 248, 0.5), rgba(90, 156, 248, 0.5)), linear-gradient(to top, #5a9cf8, #90befd);
  }
    .agreement-dialog {
        width: 100%;
        height: 100%;
    }
    .agreement-tips{
        position: absolute;
        bottom: 170px;
        left: 50%;
        margin-left:-180px ;
        display: inline-block;
        font-size: 12px;
        color: #f76c5e;
        padding: 2px 10px;
        background-color: #fee9e7;
        border-radius: 4px;
    }
</style>
<template>
  <div class="agreement-dialog">
    <el-dialog :visible="showDialog" @close="close" width="80%">
      <!-- 您好，您尚未签署平台服务协议，为更好地给您提供完整的平台服务，您需要先签署该协议 -->
      <div class="agreement-title">
        {{$t('tips.agreementFirstPlatformServices')}}
      </div>
      <div class="agreement-content">
          <iframe :src="pdfUrl" frameborder="0" width='100%' height='100%'></iframe>
          <!-- 您需要阅读完成整个协议再签署，谢谢配合。 -->
          <div class="agreement-tips">{{$t('tips.needAgreementSigning')}}</div>
      </div>
      <div class="agreement-action">
        <!-- 通过点击此按钮，你同意并确认： -->
        <el-checkbox v-model="checked">{{$t('tips.clickingButtonConfirm')}}</el-checkbox>
        <!-- 1、你同意本平台服务协议的以下条款； -->
        <p>{{$t('tips.agreedFollowingTerms')}}</p>
        <!-- 2、为《电子交易条例》（香港法律第553章）之目的，该行为构成你对本平台服务协议的电子签署。 -->
        <p>{{$t('tips.constitutesElectronicSignature')}}</p>
        <!-- 确定签署 -->
        <div class="agreement-btn" @click="saveStatus">{{$t('tips.confirmToSign')}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['show','pdfUrl','layerLoading'],
  data () {
    return {
      checked: false,
      // showDialog: false,
    }
  },
  computed:{
      showDialog(){
          return this.show
      }
  },
  watch: {
    // show (val) {
    //   this.showDialog = val
    // }
  },
  methods: {
    close () {
      this.show = false
      this.$emit('close')
    },
    saveStatus () {
        if(this.layerLoading)return
        if(this.checked){
            this.$emit('sure')
        }else {
          // '请点击按钮，同意并确认'
            this.$message({
                type: 'error',
                showClose: true,
                message: this.$t('tips.clickAgreeConfirm')
            });
        }

    },

  },
    mounted(){

    },
}
</script>
